import Container from './settings-navigation-container';

export default Container;
